var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Header',{on:{"selCat":_vm.selCat,"selPrice":_vm.selPrice}})],1),_c('div',[_c('Middle',{ref:"goodsListContent",attrs:{"msg":"一件起订"},on:{"initCart":_vm.initCart}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }